import { MAX_VELOCITY_FILTERS } from '@brighterion/utils/constants';
import { PARAMETERS_PARAM_TYPES } from 'Common/enums';
import _ from 'lodash';

export const isFilterConditionFilled = (customCondition: CustomFilterConditionObj) => {
    return (
        !_.isEmpty(String(customCondition?.parameter)) &&
        !_.isEmpty(String(customCondition?.operator)) &&
        !_.isEmpty(String(customCondition?.value)) &&
        !_.isEmpty(String(customCondition?.type))
    );
};

export const isAllFilterConditionsValid = (customConditions: CustomFilterConditionObj[]) => {
    // Check if the length of customConditions is greater than MAX_VELOCITY_FILTERS
    if (customConditions.length >= MAX_VELOCITY_FILTERS) {
        return false;
    }

    // Check if any condition is unfilled
    const anyUnfilledCondition = customConditions.some((condition) => !isFilterConditionFilled(condition));

    // Return true if all conditions are filled and the length is within the limit
    return !anyUnfilledCondition;
};

export const getOperatorOptions = (type: string, allowListOperators: boolean) => {
    switch (type) {
        case PARAMETERS_PARAM_TYPES.STRING:
            return allowListOperators
                ? ['eq', 'neq', 'strinlist', 'strnotinlist', 'strcontains', 'strnotcontains']
                : ['eq', 'neq', 'strcontains', 'strnotcontains'];
        case PARAMETERS_PARAM_TYPES.CURRENCY:
            return ['eq', 'neq', 'gt', 'lt', 'ge', 'le'];
        case PARAMETERS_PARAM_TYPES.NUMBER:
            return allowListOperators
                ? ['eq', 'neq', 'gt', 'lt', 'ge', 'le', 'strinlist', 'strnotinlist']
                : ['eq', 'neq', 'gt', 'lt', 'ge', 'le'];
        case PARAMETERS_PARAM_TYPES.PAN:
            return allowListOperators ? ['strinlist', 'strnotinlist'] : [];
        default:
            return allowListOperators
                ? ['eq', 'neq', 'gt', 'lt', 'ge', 'le', 'strinlist', 'strnotinlist', 'strcontains', 'strnotcontains']
                : ['eq', 'neq', 'gt', 'lt', 'ge', 'le', 'strcontains', 'strnotcontains'];
    }
};
